export const Div = (props) => {

    const {justify = 'center', align = 'center', style, direction='row', onMouseOver=null, onMouseLeave=null} = props
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: direction,
                justifyContent: justify,
                alignItems: align,
                flex: 1,
                width: '100%',
                ...style
            }}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
        >
            {props.children}
        </div>
    )
}